export default __webpack_public_path__ + "static/media/ba19.6963a981.jpg";